import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Paper,
  Grid,
  Button
} from '@mui/material';
import { Message as MessageIcon, Email as EmailIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import HarvestContacts from './HarvestContacts';
import HarvestForm from './HarvestForm';
import HarvestStats from './HarvestStats';
import HarvestLocations from './HarvestLocations';

function Harvest() {
  const navigate = useNavigate();
  const { organizationSlug } = useParams();
  const { organizationSlug: authOrgSlug } = useAuth();
  const currentOrgSlug = organizationSlug || authOrgSlug;
  const [activeTab, setActiveTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              Harvest Outreach System
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Manage contacts collected during Saturday evangelism outreach
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                const smsPath = currentOrgSlug ? `/${currentOrgSlug}/sms` : '/sms';
                navigate(smsPath);
              }}
              startIcon={<MessageIcon />}
              sx={{ px: 4, py: 1.5 }}
            >
              Send SMS Messages
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                const emailPath = currentOrgSlug 
                  ? `/${currentOrgSlug}/email-composer?audienceType=harvest_contacts`
                  : '/email-composer?audienceType=harvest_contacts';
                navigate(emailPath);
              }}
              startIcon={<EmailIcon />}
              sx={{ px: 4, py: 1.5 }}
            >
              Send Email Campaign
            </Button>
          </Box>
        </Box>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Add New Contact" />
          <Tab label="View Contacts" />
          <Tab label="Statistics" />
          <Tab label="Manage Locations" />
        </Tabs>
      </Paper>

      <Box sx={{ mt: 3 }}>
        {activeTab === 0 && (
          <HarvestForm organizationSlug={currentOrgSlug} onContactAdded={handleRefresh} />
        )}
        {activeTab === 1 && (
          <HarvestContacts organizationSlug={currentOrgSlug} refreshTrigger={refreshTrigger} />
        )}
        {activeTab === 2 && (
          <HarvestStats refreshTrigger={refreshTrigger} />
        )}
        {activeTab === 3 && (
          <HarvestLocations organizationSlug={currentOrgSlug} refreshTrigger={refreshTrigger} />
        )}
      </Box>
    </Container>
  );
}

export default Harvest;
